import { useRef, useEffect, useState, ReactNode } from "react";
import { createPortal } from "react-dom";

interface PortalProps {
	children: ReactNode;
}

export const Portal = (props: PortalProps) => {
	const ref = useRef<Element | null>(null);
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		ref.current = document.querySelector<HTMLElement>("#portal");
		setMounted(true);
	}, []);

	return mounted && ref.current
		? createPortal(
				<div className="portal-layout">
					{props.children}
					<style jsx>{`
						.portal-layout {
							display: block;
							position: fixed;
							left: 0;
							top: 0;
							width: 100%;
							height: 100%;
							overflow: auto;
							z-index: 1;
							background-color: var(--rf-color-background);
						}
					`}</style>
				</div>,
				ref.current,
			)
		: null;
};
